import LazyLoad from 'react-lazyload'
import PropTypes from 'prop-types'
import React, {Component, Fragment} from 'react'
import isEqual from 'lodash/isEqual'
import {EffectEvent} from './tracking'
import {colors} from '../styles'
import {connect} from 'react-redux'
import {css} from 'glamor'

const style = {
  image: css({
    color: colors.grayLightest,
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    '& > img': {
      width: '100%'
    }
  }),
  imageResponsive: css({
    '> img': {
      display: 'block',
      height: 'auto',
      maxWidth: '100%'
    }
  }),
  imageLoading: css({
    '&::before': {
      background: 'currentColor',
      bottom: 0,
      content: ' ',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0
    },
    '&::after': {
      animation: 'spinner 0.6s linear infinite',
      border: '2px solid currentColor',
      borderTopColor: colors.primaryBG,
      borderRadius: '10px',
      content: ' ',
      height: '20px',
      left: '50%',
      margin: '-10px 0 0 -10px',
      position: 'absolute',
      top: '50%',
      width: '20px'
    }
  })
}

class LazyLoadImage extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: !props.bot}
  }

  componentDidMount() {
    if (this.ref && this.ref.complete) {
      this.setState({loading: false})
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props) && this.ref && !this.ref.complete) {
      this.setState({loading: true})
    }
  }

  onRef = (ref) => {
    this.ref = ref
  }

  onLoad = () => {
    const {onLoad} = this.props
    this.setState({loading: false}, () => onLoad && onLoad())
  }

  onError = () => {
    const {onError} = this.props
    this.setState({loading: false, error: true}, () => onError && onError())
  }

  render() {
    const {
      bot,
      dispatch, // eslint-disable-line no-unused-vars
      event,
      force,
      onError, // eslint-disable-line no-unused-vars
      onLoad, // eslint-disable-line no-unused-vars
      placeholder,
      responsive,
      src,
      style: styleProps,
      ...rest
    } = this.props

    let imageStyle = style.image
    if (this.state.loading && !force) {
      imageStyle = css(imageStyle, style.imageLoading)
    }

    if (styleProps) {
      imageStyle = css(imageStyle, styleProps)
    }

    if (responsive) {
      imageStyle = css(imageStyle, style.imageResponsive)
    }

    return (
      <span {...imageStyle}>
        {force || bot ? (
          <img src={src} {...rest} />
        ) : (
          <LazyLoad height="100%" once placeholder={placeholder}>
            <Fragment>
              <img
                onError={this.onError}
                onLoad={this.onLoad}
                ref={this.onRef}
                src={src}
                {...rest}
              />
              {event && <EffectEvent {...event} />}
            </Fragment>
          </LazyLoad>
        )}
      </span>
    )
  }
}

LazyLoadImage.propTypes = {
  bot: PropTypes.bool,
  dispatch: PropTypes.func,
  event: PropTypes.object,
  force: PropTypes.bool,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  placeholder: PropTypes.any,
  responsive: PropTypes.bool,
  src: PropTypes.string,
  style: PropTypes.object
}

LazyLoadImage.defaultProps = {
  bot: false,
  force: false,
  placeholder: <img />
}

const stateToProps = ({bot}) => ({bot})

export default connect(stateToProps)(LazyLoadImage)
